module.exports = __webpack_public_path__ + "static/media/tiktok-winner.bb007abb.jpg";